.input {
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  margin: 18px 0;
  line-height: 40px;
  font-size: 16px;
  font-family: 'Helvetica', sans-serif;
  padding: 0 10px;
}
.label {
  height: 0;
  width: 0;
  display: block;
  overflow: hidden;
  text-indent: -50000px;
}